import React, { useState, useEffect } from 'react'
import BackNavbarLearning from '../../../ReusableBlocks/Navbar'
import { Link } from "react-router-dom";
import Footer from '../../../ReusableBlocks/FooterBlock'
import Modal from 'react-bootstrap/Modal';
import LoadingBar from '../../../Images/Animation - 1710409471189.json'
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLearningHub } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import CryptoJS from 'crypto-js';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import * as PATH from '../../../CentralisedLink'
import BmcLogo from '../../../Images/dsmlogoblack.png'
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';

const NINJA_BADGE_URL = 'https://dsomtechcentral.s3.eu-north-1.amazonaws.com/Learning+Hub/Platform/Dashboards/Badge/TC+(2).png';


const LearningHubHome = (props) => {


  const secretKey = 'micro';

  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
    return encodeURIComponent(ciphertext);
  };
  const currentUser = useSelector(state => state.auth.currentUser);
  const [showSubCourses, setShowSubCourses] = useState(false);
  const [screenSize, setScreenSize] = useState('');
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [activeTab, setActiveTab] = useState('suggested');
  const [fullPageloading, setFullPageLoading] = useState(true);
  const [loadingAnimation, setLoadingAnimation] = useState(LoadingBar);
  const [loadingTitle, setLoadingTitle] = useState("Ingestion In Progress!");

  const [suggestedCount, setSuggestedCount] = useState(0);
  const [completedCount, setCompletedCount] = useState(0);


  const [badgde, setbadgde] = useState('');
  const [badgeModel, setBadgdeModel] = useState(false)

  const dispatch = useDispatch();
  const { getData } = useSelector((state) => state.LearningHubData);


  const isLoading = useSelector(state => state.LearningHubData?.loading);
  const errorMessage = useSelector(state => state.LearningHubData?.error);



  const mandatoryTraining = getData?.['mandatory-training'] || [];


  console.log(mandatoryTraining)


  const tracksData = getData?.['tracks'] || []

  const handleShowWhatsNew = () => setShowWhatsNew(true);
  const handleCloseWhatsNew = () => setShowWhatsNew(false);

  const handleShowBadgdeModel = (badge) => {
    console.log(badge)
    setbadgde(badge)
    setBadgdeModel(true);
  }
  const handleCloseBadgdeModel = () => setBadgdeModel(false);




  useEffect(() => {
    setFullPageLoading(true)
    setTimeout(() => {
      setFullPageLoading(false)
    }, 3000);





  }, [])

  useEffect(() => {
    dispatch(fetchLearningHub());
  }, [dispatch]);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScreenSize('mobile');
      } else if (width <= 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener('resize', handleResize); // Add event listener for resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup on component unmount
    };
  }, []);



  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });;
    }
  }, [errorMessage]);



  useEffect(() => {
    // Calculate suggested and completed counts
    let suggestedCount = 0;
    let completedCount = 0;

    if (mandatoryTraining.trainingCompletionStatus) {
      completedCount += 1;
    } else {
      suggestedCount += 1;
    }

    tracksData.forEach((track) => {
      if (track.trackCompletionStatus) {
        completedCount += 1;
      } else {
        suggestedCount += 1;
      }
    });

    setSuggestedCount(suggestedCount);
    setCompletedCount(completedCount);
  }, [mandatoryTraining, tracksData]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };


  const renderHeroContent = () => {
    if (currentUser?.typeOfUser === 'External SE') {
      return (
        <h6 className='learning-hub-her-content-h1'>Welcome to <b>Partner</b> Learning<span className='learning-hub-her-content-h1-span'>Hub</span></h6>
      );
    } else {
      return (
        <h6 className='learning-hub-her-content-h1'>Welcome to Learning<span className='learning-hub-her-content-h1-span'>Hub</span></h6>
      );
    }
  }
  



  const renderCourses = () => {

    const trainingCompletionStatus = mandatoryTraining?.trainingCompletionStatus;
    const completedTracks = tracksData?.filter(track => track.trackCompletionStatus);
    const suggestedTracks = tracksData?.filter(track => !track.trackCompletionStatus);

    if (activeTab === 'completed') {
      return (
        <div className="completed-courses">
          {trainingCompletionStatus && (
            <div className="course-card">
              <div className="course-image">
                <img src={normalizeMediaUrl(mandatoryTraining?.certThumbnail, 'image')} alt="Course Showcase" />
              </div>
              <div className="course-details">
                <h2 className="training-title">{mandatoryTraining?.title}</h2>
                <div className="cour-dist">
                  <p className="course-dist-det">
                    <span className="cougrse-dist-det-one">&#8226; 1 Hour</span>
                    <span className="course-dist-det-two">&#8226; 1 modules</span>
                    <span className="course-dist-det-two-green">&#8226; Completed</span>
                  </p>
                </div>
                <p className="course-det-paragraph">{mandatoryTraining?.shortDescription}</p>
                <button className="badge-button-short" onClick={() => handleShowBadgdeModel(mandatoryTraining?.completionBadge)}>Download Badge</button>
              </div>
            </div>
          )}
          {completedTracks?.length > 0 ? (
            completedTracks.map((track, index) => (
              <div className="course-card" key={index}>
                <div className="course-image">
                  <img src={normalizeMediaUrl(track?.thumbnail, 'image')} alt="Course Showcase" />
                </div>
                <div className="course-details">
                  <h1 className="training-title">{track?.trackTitle}</h1>
                  <div className="line-lear"></div>
                  <div className="cour-dist">
                    <p className="course-dist-det">
                      <span className="cougrse-dist-det-one">&#8226; {track?.totalDuration}</span>
                      <span className="course-dist-det-two">&#8226; {track?.microcertsList.length} Microcerts</span>
                    </p>
                  </div>
                  <p className="para-lear">{track?.trackDescription}</p>
                  <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.trackTitle}`}><p className="launch-button">Show Courses <i className="fa-solid fa-angles-right"></i></p></Link>
                </div>
              </div>
            ))
          ) : (
            <p>Nothing to Show</p>
          )}
        </div>
      );
    } else {
      return (
        <div className="suggested-courses">
          {!trainingCompletionStatus && (
            <div className="course-card">

              <div className="course-image">
                <img src={normalizeMediaUrl(mandatoryTraining.certThumbnail, 'image')} alt="Course Showcase" />
              </div>
              <div className="course-details">
                <h1 className="training-title">{mandatoryTraining.title}</h1>
                <div className="line-lear"></div>
                <div className="cour-dist">
                  <p className="course-dist-det">
                    <span className="cougrse-dist-det-one">&#8226; {mandatoryTraining?.completionTime}</span>
                    <span className="course-dist-det-two">&#8226; 1 modules</span>
                  </p>
                </div>
                <p className="para-lear">{mandatoryTraining.shortDescription}</p>
                <Link to={`${PATH.LEARNING_HUB_MANDATORY_TRAINING_PATH}${encryptId(mandatoryTraining.certId)}`}><p className="launch-button">Launch now {`>>`}</p></Link>
              </div>
            </div>
          )}

          {suggestedTracks?.length > 0 ? (
            <div>
              <br></br>
              <p className="available-tracks">Available Tracks ({suggestedTracks.length})</p>
              {suggestedTracks?.map((track, index) => (
                <div className="course-card" key={index}>
                  <div className="course-image">
                    <img src={normalizeMediaUrl(track?.thumbnail, 'image')} alt="Course Showcase" />
                  </div>
                  <div className="course-details">
                    <h1 className="training-title">{track?.trackTitle}</h1>
                    <div className="line-lear"></div>
                    <div className="cour-dist">
                      <p className="course-dist-det">
                        <span className="cougrse-dist-det-one">&#8226; {track?.totalDuration}</span>
                        <span className="course-dist-det-two">&#8226; {track?.microcertsList.length} Microcerts</span>
                      </p>
                    </div>
                    <p className="para-lear">{track?.trackDescription}</p>
                    <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.trackTitle}`}><p className="launch-button">Show Courses <i className="fa-solid fa-angles-right"></i></p></Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            trainingCompletionStatus && (
            <center>
              <div class="card-completion">
                <div class="card-content">

                  <h2 class="title-completion">Great Job!</h2>
                  <p class="message-completion">
                    Congratulations! 🎓 You’ve successfully completed all the tracks. If any new microcerts are added, you can find them in the Suggested tab. Keep up the great work!
                  </p>

                  <div class="section-ninja-badge">
                    <img src={normalizeMediaUrl(NINJA_BADGE_URL, 'image')} alt="Ninja Badge" class="badge-ninja" />
                    <br></br>
                    <p class="text-badge">You've earned the Ninja Badge! 🏆</p>
                    <div class="actions-badge">
                      <a
                        href={normalizeMediaUrl(NINJA_BADGE_URL, 'download')}
                        download="DSOM_Tech_Central_Ninja_Badge.png"
                        class="nina-btn-download"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Download Badge
                      </a>
                      <button className="nina-btn-linkedin" onClick={() => shareOnLinkedIn(normalizeMediaUrl(NINJA_BADGE_URL, 'image'))}>
                        Share on LinkedIn
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </center>
            )

          )}
        </div>
      );
    }
  };




  



  const toggleSubCourses = () => {
    setShowSubCourses(!showSubCourses);
  };




  // Settings for the carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: screenSize === 'mobile' ? 1 : screenSize === 'tablet' ? 3 : screenSize === 'desktop' ? 4 : 2,
    slidesToScroll: 1
  };


  const downloadBadge = (badgde) => {
    const link = document.createElement('a');
    link.href = badgde;
    window.open(badgde, '_blank');
  };

  const shareOnLinkedIn = (badgde) => {
    const badgeUrl = encodeURIComponent(badgde);
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${badgeUrl}`;
    window.open(linkedInUrl, '_blank');
  };



  return (
    <>
      {isLoading && <LoadingScreen text="Getting Learning Hub Data" />}


      <BackNavbarLearning activeTabSales={"LEARNING_HUB"}/>



      {/* Top Hero Section */}
      <section >
        <div className='learning-hub-her-sec'>
          <div className='container'>
            <div className='learning-hub-her-content'>
             {renderHeroContent()}
              <div class="line-learning"></div>
              <p className='learning-hub-her-content-p'>Discover Learning Hub: Your Gateway to Knowledge!</p>
            </div>
          </div>
        </div>
      </section>




      {/* Tabs and Search */}
      <section >
        <div className='tabs-search-sec'>
          <div className='container'>
            <div className='tabs-search-flex-one'>

              <div className='tabs-search-flex-two'>

                <div className={`tab ${activeTab === 'suggested' ? 'active' : ''}`} onClick={() => handleTabChange('suggested')}>
                  <div className='lear-dis-flex'>
                    <p className='sugges-p'>Suggested </p>
                    <p className='sugges-p-count'>{suggestedCount}</p>
                  </div>
                </div>
                <div className={`tab ${activeTab === 'completed' ? 'active' : ''}`} onClick={() => handleTabChange('completed')}>
                  <div className='lear-dis-flex'>
                    <p className='sugges-p'>Completed </p>
                    <p className='sugges-p-count'>{completedCount}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>




      {/* Main Content */}
      <div className='background-color'>
        <br></br>
        <div className='container'>
          {renderCourses()}
          <br></br>
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>



      {/* New modal for displaying search results */}
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        show={badgeModel}
        onHide={() => handleCloseBadgdeModel()}
        fullscreen={false}
      >
        <Modal.Body className='badgde-body'>
          <img className='badgde-cert' src={normalizeMediaUrl(badgde, 'image')} alt="Completion badge" />
          <div className='badgde-btn'>
            <button className='download-badgde' onClick={() => downloadBadge(badgde)}>Download Badge</button>
            <button className='share-linkdin' onClick={() => shareOnLinkedIn(badgde)}>Share On LinkedIn</button>
          </div>
        </Modal.Body>
      </Modal>



    </>
  )
}

export default LearningHubHome
